import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TxtAdd } from '../interfaces/txtAdd';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';

@Injectable({
  providedIn: 'root'
})
export class TxtAddService {  

  readonly url = `${environment.apiURL}/texto/adicional`;

  constructor(private http: HttpClient) { }

  saveOrUpdate(cadastro: TxtAdd): Observable<TxtAdd> {
    return this.http.put<TxtAdd>(`${this.url}`, cadastro);
  }

  getTxtAdd(id: number ): Observable<TxtAdd> {
    return this.http.get<TxtAdd>(`${this.url}/${id}`);
  }

  getTxtAddPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<TxtAdd>> {
    const params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20))
      .set('order', order ?? 'NENHUM')
      .set('direction', direction ?? 'ASC');
    return this.http.get<PageResult<TxtAdd>>(`${this.url}/page/get/`, { params });
  }

  getTxtAddPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<TxtAdd>> {
    let params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20))
      .set('order', order ?? 'NENHUM')
      .set('direction', direction ?? 'ASC');
    if (search) {
      params = params.set('search', search);
    }
    return this.http.get<PageResult<TxtAdd>>(`${this.url}/page/get/`, { params });
  }

  doesCodeExist(code: any, uuid: string) {
    return this.http.get<boolean>(`${this.url}/${code}?uuid=${uuid}`);
  }

}
